import axios from 'axios'
import ApiValues from '../url/apiurl'
import labels from '../../utils/constants/labels';
import Networking from '../../utils/api/apiaccess';
/* name should be camel case in all function */
function getEPFReport(clientID,accountTypeID,accountID,userID) {
  const BaseUrl = ApiValues.EpfReport + `clientID=${clientID}&accountTypeID=${accountTypeID}&accountID=${accountID}&userID=${userID}`


  //AsOnDate

  // return fetch(BaseUrl, {
  //   method: 'POST',
  //   headers: {
  //     'Accept': 'application/json',
  //     'Content-Type': 'application/json',
  //   },
  // })
  //   .then((response) => response.json())
  //   .then((responseJson) => {
  //     return responseJson
  //   })
  //   .catch((error) => {
  //     return { "status": "F", "mes  sage": labels.messages.apierror }
  //   });
  return Networking.GetApi(BaseUrl).then(result => { return result })
    .catch(function (error) {
      return { "status": "F", "message": labels.messages.apierror }

      // 
    });

}
export default getEPFReport
